import toastMixin from "./toastMixin";
import HttpError from "../Api/Utils/HttpError";
import { translate } from "./translations";
import translatorMixin from "./translatorMixin";

const TIMEOUT = 3000;

export default {
    mixins: [toastMixin, translatorMixin],
    methods: {
        handlePlainError(err) {
            //@ts-expect-error Fix later
            this.errorToast(err.message, TIMEOUT);
        },
        handleError(err: HttpError) {
            console.error(err);

            let message: string;
            if (err.alreadyTranslated) {
                message = err.message;
            } else if (err.statusCode === 403) {
                message = translate(err.message) ?? translate("error.forbidden");
            } else {
                message = translate(err.message) ?? translate("error.default");
            }

            //@ts-expect-error Fix later
            this.errorToast(message, TIMEOUT);
        },
    },
};
